import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import {
  getJobPositionList,
  getJobPositionDetails,
  postJobPosition,
  putJobPosition,
  deleteJobPosition,
} from '../../services/jobPositionsSvc'

import {
  GET_JOB_POSITION_LIST,
  GET_JOB_POSITION_DETAILS,
  PUT_JOB_POSITION,
  DELETE_JOB_POSITION,
  POST_JOB_POSITION,
  RESET_JOB_POSITION_STATE,
} from './constants'

export const resetJobPositionStateAct = createAction(RESET_JOB_POSITION_STATE)

export const getJobPositionListAct = createAsyncThunk(
  GET_JOB_POSITION_LIST,
  async (params, { fulfillWithValue, rejectWithValue }) => {
    try {
      const resp = await getJobPositionList(params)
      return fulfillWithValue(resp)
    } catch (error) {
      return rejectWithValue(error?.data?.error)
    }
  },
)

export const postJobPositionAct = createAsyncThunk(
  POST_JOB_POSITION,
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const resp = await postJobPosition(payload)
      return fulfillWithValue(resp.data)
    } catch (error) {
      return rejectWithValue(error?.data?.error)
    }
  },
)

export const getJobPositionDetailsAct = createAsyncThunk(
  GET_JOB_POSITION_DETAILS,
  async (jobPositionId, { fulfillWithValue, rejectWithValue }) => {
    try {
      const resp = await getJobPositionDetails(jobPositionId)
      return fulfillWithValue(resp.data)
    } catch (error) {
      return rejectWithValue(error?.data?.error)
    }
  },
)

export const putJobPositionAct = createAsyncThunk(
  PUT_JOB_POSITION,
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const resp = await putJobPosition(payload)
      return fulfillWithValue(resp.data)
    } catch (error) {
      return rejectWithValue(error?.data?.error)
    }
  },
)

export const deleteJobPositionAct = createAsyncThunk(
  DELETE_JOB_POSITION,
  async (params, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { id, ...filter } = params
      await deleteJobPosition({ id })
      const resp = await getJobPositionList(filter)
      return fulfillWithValue(resp.data)
    } catch (error) {
      return rejectWithValue(error?.data?.error)
    }
  },
)
